<div class="FormsItinerary">
    @if (isLoading || isSaving) {
        <app-pg-loading [isOverlay]="isSaving"></app-pg-loading>
    }
    @if (!isLoading) {
        @if (viewOnly) {
            <div [hidden]="createModalData != null">
                <app-pg-detail [formLayout]="formLayout" [hideEmpty]="true" [currentLanguage]="true"></app-pg-detail>
                <div class="FormsItinerary-View">
                    <h4 class="mb-3">{{ 'forms-itinerary.itinerary-stops' | locTranslate }}</h4>
                    <div class="FormsItinerary-View-Map mb-3">
                        @if (isFullyLoaded) {
                            <app-ef-itinerary-map [itineraryData]="itineraryData"></app-ef-itinerary-map>
                        }
                    </div>
                    <div>
                        <div class="row">
                            @for (item of itineraryData.collection; track item) {
                                <div class="FormsItinerary-Item col-12 col-md-6 col-lg-4">
                                    <div class="FormsItinerary-Item-Content">
                                        <app-ef-itinerary-stop-card [singleDay]="itineraryData.single_day" [stopData]="item" (showStop)="editItineraryStopItem(item)"></app-ef-itinerary-stop-card>
                                    </div>
                                </div>
                            }
                        </div>

                        @if (itineraryData.services?.length) {
                            <h4 class="my-3">{{ 'forms-itinerary.itinerary-services' | locTranslate }}</h4>
                            <div class="row">
                                @for (item of itineraryData.services; track item) {
                                    <div class="FormsItinerary-Item col-12 col-md-6 col-lg-4">
                                        <div class="FormsItinerary-Item-Content">
                                            <app-ef-itinerary-stop-card [stopData]="item" [disabled]="true"></app-ef-itinerary-stop-card>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (!viewOnly) {
            <div [hidden]="createModalData != null">
                <app-pg-form #formComponent [formLayout]="formLayout" [hasSubmit]="false" [hideAdvanced]="true" (advancedModeChange)="onAdvancedModeChange($event)" [forceLanguage]="selectedLanguage" (valueChange)="onValueChange($event)">
                    @if (itineraryData != null) {
                        <div>
                            <div class="my-3 pt-3 border-top d-flex justify-content-between align-items-center">
                                <h4 class="m-0">{{ 'forms-itinerary.itinerary-stops' | locTranslate }}</h4>
                                <div class="d-flex align-items-center">
                                    <span class="me-2">{{ 'forms-itinerary.itinerary-single-day' | locTranslate }}</span>
                                    <app-pg-switch [small]="true" [ariaLabel]="'forms-itinerary.itinerary-single-day' | locTranslate" [(ngModel)]="itineraryData.single_day" (ngModelChange)="onSingleDayChange()"></app-pg-switch>
                                </div>
                            </div>
                            <div class="row">
                                @for (item of itineraryData.collection; track item; let i = $index) {
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <div class="FormsItinerary-Item mb-3 card">
                                            <div class="FormsItinerary-Item-Buttons">
                                                <button type="button" [disabled]="i <= 0" class="btn btn-link" (click)="moveItineraryItemPrev(item)"
                                                    [attr.aria-label]="'forms-main.a11y.move-left' | locTranslate">
                                                    <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                                                </button>
                                                <button type="button" [disabled]="i >= itineraryData.collection.length - 1" class="btn btn-link" (click)="moveItineraryItemNext(item)"
                                                    [attr.aria-label]="'forms-main.a11y.move-right' | locTranslate">
                                                    <i class="fa-regular fa-chevron-right" aria-hidden="true"></i>
                                                </button>
                                                <div>
                                                    <button type="button" class="btn btn-link text-primary" (click)="editItineraryStopItem(item)"
                                                        [attr.aria-label]="'forms-main.a11y.edit-item' | locTranslate">
                                                        <i class="fa-regular fa-edit" aria-hidden="true"></i>
                                                    </button>
                                                    <app-pg-confirm-action (confirmed)="deleteItineraryStopItem(item)">
                                                        <button type="button" class="btn btn-link text-danger"
                                                            [attr.aria-label]="'forms-main.a11y.delete-item' | locTranslate">
                                                            <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                                        </button>
                                                    </app-pg-confirm-action>
                                                </div>
                                            </div>
                                            <div class="FormsItinerary-Item-Content">
                                                <app-ef-itinerary-stop-card [singleDay]="itineraryData.single_day" [disabled]="true" [stopData]="item"></app-ef-itinerary-stop-card>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="FormsItinerary-Item mb-3">
                                        <div class="card bg-white">
                                            <div class="card-body">
                                                <h5 class="mb-3">{{ 'forms-itinerary.itinerary-item-add-stop' | locTranslate }}</h5>
                                                <div class="form-text mb-3">
                                                    <span>{{ 'forms-itinerary.itinerary-item-add-stop-text' | locTranslate }}</span>
                                                </div>
                                                <div>
                                                    <div class="form-group">
                                                        <label><b>{{ 'forms-itinerary.itinerary-item-type' | locTranslate }}</b></label>
                                                        <app-pg-select [options]="addStopResourceOptions" [(ngModel)]="addStopResourceSelected" (ngModelChange)="addStopElementSelected = null" display="oneLine"></app-pg-select>
                                                        @if (addStopResourceSelected == 'Poi') {
                                                            <div class="mt-2">
                                                                <app-pg-select [readonly]="addStopResourceSelected == null" [options]="addStopPoiParametersOptions" [(ngModel)]="addStopPoiParametersValue" [required]="true" display="oneLine"></app-pg-select>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="form-group">
                                                        @if (addStopResourceSelected != 'External') {
                                                            <label>
                                                                <b>{{ 'forms-itinerary.itinerary-item' | locTranslate }}</b>
                                                            </label>
                                                            <div>
                                                                @if(getAddStopElementParameters(); as params) {
                                                                    <app-pg-select [readonly]="addStopResourceSelected == null" 
                                                                        [options]="addStopResourceSelected == null || addStopResourceSelected == 'External' ? [] : null" [optionsFilter]="params.filter"
                                                                        [resource]="addStopResourceSelected == 'External' ? null : addStopResourceSelected" [resourceMode]="params.mode" 
                                                                        [(ngModel)]="addStopElementSelected" display="oneLine" [resourceSemantic]="resourceSemantics[addStopResourceSelected]"></app-pg-select>
                                                                }
                                                            </div>
                                                        }
                                                        @else {
                                                            <label>
                                                                <b>{{ 'forms-itinerary.itinerary-url' | locTranslate }}</b>
                                                            </label>
                                                            <div>
                                                                <input type="text" class="form-control" [(ngModel)]="addStopElementSelected"/>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="text-end">
                                                        <button [disabled]="addStopResourceSelected == null || addStopResourceSelected == 'External'" class="btn btn-primary" (click)="createStopResourceElement()">
                                                            <span>{{ 'forms-itinerary.itinerary-item-create' | locTranslate }}</span>
                                                        </button>
                                                        <button [disabled]="addStopResourceSelected == null || addStopElementSelected == null || addStopElementSelected == '' || isAddingStopResourceElement" class="btn btn-primary ms-2" (click)="addStopResourceElement()">
                                                            <span>{{ 'forms-itinerary.itinerary-item-add' | locTranslate }}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div [appPgAnimations]="formLayout.advancedMode ? 'EnterL' : 'ExitL'">
                                <div class="my-3 pt-3 border-top d-flex justify-content-between align-items-center">
                                    <h4 class="m-0">{{ 'forms-itinerary.itinerary-services' | locTranslate }}</h4>
                                </div>
                                <div class="row">
                                    @for (item of itineraryData.services; track item; let i = $index) {
                                        <div class="col-12 col-md-6 col-lg-4">
                                            <div class="FormsItinerary-Item mb-3 card">
                                                <div class="FormsItinerary-Item-Buttons">
                                                    <div>
                                                        <app-pg-confirm-action (confirmed)="deleteItineraryServiceItem(item)">
                                                            <button type="button" class="btn btn-link text-danger"
                                                                [attr.aria-label]="'forms-main.a11y.delete-item' | locTranslate">
                                                                <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                                            </button>
                                                        </app-pg-confirm-action>
                                                    </div>
                                                </div>
                                                <div class="FormsItinerary-Item-Content">
                                                    <app-ef-itinerary-stop-card [disabled]="true" [stopData]="item"></app-ef-itinerary-stop-card>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <div class="FormsItinerary-Item mb-3">
                                            <div class="card bg-white">
                                                <div class="card-body">
                                                    <h5 class="mb-3">{{ 'forms-itinerary.itinerary-item-add-service' | locTranslate }}</h5>
                                                    <div>
                                                        <div class="form-group">
                                                            <label><b>{{ 'forms-itinerary.itinerary-item-type' | locTranslate }}</b></label>
                                                            <app-pg-select [options]="addServiceResourceOptions" [(ngModel)]="addServiceResourceSelected" (ngModelChange)="addServiceElementSelected = null" display="oneLine"></app-pg-select>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="form-group">
                                                            <label><b>{{ 'forms-itinerary.itinerary-item' | locTranslate }}</b></label>
                                                            <div>
                                                                <app-pg-select [readonly]="addServiceResourceSelected == null" [options]="addServiceResourceSelected == null ? emptyOptions : null" [resource]="addServiceResourceSelected" [(ngModel)]="addServiceElementSelected" display="oneLine" [resourceSemantic]="resourceSemantics[addServiceResourceSelected]"></app-pg-select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="text-end">
                                                            <button [disabled]="addServiceResourceSelected == null" class="btn btn-primary" (click)="createServiceResourceElement()">
                                                                <span>{{ 'forms-itinerary.itinerary-item-create' | locTranslate }}</span>
                                                            </button>
                                                            <button [disabled]="addServiceResourceSelected == null || addServiceElementSelected == null" class="btn btn-primary ms-2" (click)="addServiceResourceElement()">
                                                                <span>{{ 'forms-itinerary.itinerary-item-add' | locTranslate }}</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </app-pg-form>
            </div>
        }
    }

    @if (createModalType != null) {
        <div class="FormsItinerary-CreateModal">
            <div class="modal-header border-top border-bottom my-3 py-3">
                <h5 class="modal-title">{{ 'forms-itinerary.itinerary-item-create-'  + createModalType | locTranslate }} - {{ createModalResource }}</h5>
                <button type="button" class="btn-close" [attr.aria-label]="'forms-main.a11y.close' | locTranslate" (click)="onCreateElementFormReturn({ action: 'cancel' })"></button>
            </div>
            <div class="modal-body">
                @if (createModalData == null) {
                    <app-pg-loading></app-pg-loading>
                }
                @if (createModalData != null) {
                    <div class="alert alert-warning">
                        <div>
                            <div>{{ 'forms-itinerary.itinerary-item-create-auto-publish-text' | locTranslate }}</div>
                            <div>
                                <label class="d-flex align-items-center">
                                    <app-pg-switch [small]="true" [ariaLabel]="'forms-itinerary.itinerary-item-create-auto-publish-label' | locTranslate" [(ngModel)]="createModalAutoPublish"></app-pg-switch>
                                    <b class="ps-2">{{ 'forms-itinerary.itinerary-item-create-auto-publish-label' | locTranslate }}</b>
                                </label>
                            </div>
                        </div>
                    </div>
                    @if (createModalResource == 'Experience') {
                        <app-forms-experience [elementId]="createModalData.id" [inModal]="true" (formReturn)="onCreateElementFormReturn($event)"></app-forms-experience>
                    }
                    @if (createModalResource == 'Host') {
                        <app-forms-host [elementId]="createModalData.id" [inModal]="true" (formReturn)="onCreateElementFormReturn($event)"></app-forms-host>
                    }
                    @if (createModalResource == 'Eatery') {
                        <app-forms-eatery [elementId]="createModalData.id" [inModal]="true" (formReturn)="onCreateElementFormReturn($event)"></app-forms-eatery>
                    }
                    @if (createModalResource == 'ExperienceSupplier') {
                        <app-forms-experience-supplier [elementId]="createModalData.id" [inModal]="true" (formReturn)="onCreateElementFormReturn($event)"></app-forms-experience-supplier>
                    }
                    @if (createModalResource == 'Poi') {
                        <app-forms-poi [elementId]="createModalData.id" [inModal]="true" (formReturn)="onCreateElementFormReturn($event)"></app-forms-poi>
                    }
                }
            </div>
        </div>
    }
</div>

<ng-template #editStopModal>
    <div class="modal-header">
        <div class="modal-title d-flex align-items-baseline">
            <h4 class="m-0">{{ 'forms-itinerary.itinerary-item-edit-' + (viewOnly ? 'view' : editStopModalMode) | locTranslate }}</h4>

            <div class="ms-3">
                @if (editStopItem.resource == 'External') {
                    <span class="me-2">{{ 'forms-itinerary.itinerary-item-edit-external-url' | locTranslate }}</span>
                    <a target="_blank" href="{{getEditStopItemUrl(editStopItem)}}">
                        <i class="fa-regular fa-arrow-up-right-from-square me-2 fa-sm"></i><span>{{editStopItem.element}}</span>
                    </a>
                }

                @if (editStopItem.resource != 'External' && editStopItem.element != null) {
                    <span class="me-2">{{ 'forms-itinerary.itinerary-item-edit-created-from' | locTranslate }}</span>
                    <a target="_blank" href="{{getEditStopItemUrl(editStopItem)}}">
                        <i class="fa-regular fa-arrow-up-right-from-square me-2 fa-sm"></i><span>{{editStopItem.resource}} - {{editStopItem.element}}</span>
                    </a>
                }
            </div>
        </div>

        <button type="button" class="modal-close btn btn-link" (click)="editStopModalRef.dismiss()"
            [attr.aria-label]="'forms-main.a11y.close' | locTranslate">
            <i class="fa-regular fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <div class="modal-body">
        @if(viewOnly) {
            <app-pg-detail [formLayout]="editStopLayout" [hideEmpty]="true" [currentLanguage]="true"></app-pg-detail>
        }
        @else {
            <div class="pb-1 mb-1 border-bottom">
                @if (editStopItem.resource != 'External') {
                    <div>
                        <div class="form-group">
                            <label>
                                <b>{{ 'forms-itinerary.itinerary-item' | locTranslate }}</b>
                            </label>
                            <div>
                                <app-pg-select [required]="true" [resource]="editStopItem.resource" [(ngModel)]="editStopItem.element" display="oneLine" [resourceSemantic]="resourceSemantics[editStopItem.resource]"></app-pg-select>
                            </div>
                        </div>
                    </div>
                }
            </div>

            <app-pg-form [formLayout]="editStopLayout" [hasSubmit]="false" [forceLanguage]="editStopModalSelectedLanguage"></app-pg-form>
        }
    </div>

    @if(!viewOnly) {
        <div class="modal-footer d-flex justify-content-between align-items-center">
            <div>
                @if(editStopModalLaguages.length > 1) {
                    <div class="d-flex align-items-center">
                        <div class="me-2">{{ 'pg-save-status.current-language' | locTranslate }}</div>
                        <div class="PGLanguageButtonBar">
                            @for (language of editStopModalLaguages; track language) {
                                @if (editStopModalSelectedLanguage == language || editStopModalLaguages.indexOf(language) != -1) {
                                    <button type="button"
                                        class="btn btn-sm btn-{{editStopModalSelectedLanguage == language ? 'primary' : 'secondary'}}"
                                        [attr.aria-pressed]="editStopModalSelectedLanguage == language"
                                        [disabled]="editStopModalLaguages.length < 2" (click)="editStopModalSelectedLanguage = language">
                                        {{language.split('_')[0].toUpperCase()}}
                                    </button>
                                }
                            }
                        </div>
                    </div>
                }
            </div>
            <div>
                <button class="btn btn-secondary me-2" (click)="editStopModalRef.dismiss();">{{ 'forms-itinerary.itinerary-item-edit-cancel' | locTranslate }}</button>
                <button class="btn btn-primary" (click)="editStopModalRef.close();">{{ 'forms-itinerary.itinerary-item-edit-ok' | locTranslate }}</button>
            </div>
        </div>
    }
</ng-template>